import { Injectable } from '@angular/core';
import { OrderEntry } from '../../../../core/model';
import { Occ } from '../../../../core/occ/occ-models';
import { Converter } from '../../../../core/util';

@Injectable({ providedIn: 'root' })
export class OrderEntrySerializer implements Converter<OrderEntry, Occ.ArticleLine> {
  convert(source: OrderEntry, target?: Occ.ArticleLine): Occ.ArticleLine {
    if (source) {
      target = this.convertOrderEntry(source);
    }

    return target;
  }

  private convertOrderEntry(source: OrderEntry): Occ.ArticleLine {
    if (source) {
      return {
        articleNumber: source.articleRef,
        quantity: source.quantity,
        unitCode: source.unit?.code,
        lineNote: source.note,
        statisticsCode: source.statisticsCode,
        displayNumber: source.prePrintedMaterialNumber || source.prePrintedLabel?.materialNumber,
      };
    } else {
      return undefined;
    }
  }
}
